// extracted by mini-css-extract-plugin
module.exports = {"filter":"home-component-module__F0P-QW__filter"};